var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4481 11.6827C12.4481 12.5354 11.7505 13.2322 10.8978 13.2322C10.045 13.2322 9.34826 12.5354 9.34826 11.6827V7.03233C9.34826 6.17958 10.045 5.48281 10.8978 5.48281C11.7505 5.48281 12.4481 6.17958 12.4481 7.03233V11.6827ZM12.4481 17.1077C12.4481 17.534 12.0989 17.8824 11.6725 17.8824H10.123C9.69665 17.8824 9.34826 17.534 9.34826 17.1077V15.5573C9.34826 15.1309 9.69665 14.7825 10.123 14.7825H11.6725C12.0989 14.7825 12.4481 15.1309 12.4481 15.5573V17.1077ZM21.4181 17.2179L12.9763 2.11592C12.0481 0.409579 9.7493 0.438397 8.82119 2.14559L0.379426 17.2035C-0.556389 18.9225 0.599812 20.9823 2.45703 20.9823H19.339C21.1963 20.9823 22.3525 18.9378 21.4183 17.2178L21.4181 17.2179Z",
    fill: "#EC586E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycWarning);
export default __webpack_public_path__ + "static/media/kyc-warning.265cf8ea461355339312f3e162849615.svg";
export { ForwardRef as ReactComponent };